import { EditableText } from '@blueprintjs/core'
import * as classnames from 'classnames/bind'
import * as firebase from 'firebase'
import * as R from 'ramda'
import * as React from 'react'
import { connect } from 'react-redux'
import MediaQuery from 'react-responsive'
import buttonStyles from '../../components/Button/button.scss'
import { CardContainer } from '../../components/Card'
import cardStyles from '../../components/Card/card.scss'
import ChapterSelector from '../../components/ChapterSelector'
import dragStyles from '../../components/Drag/drag.scss'
import InsightItem from '../../components/InsightItem'
import insightStyles from '../../components/InsightItem/insight.scss'
import { Dispatch, RootState, select, store } from '../../store'
import styles from './lecture-page.scss'

import Panel from './../LecturePage/launch-panel'

const cx = classnames.bind({
  ...cardStyles,
  ...dragStyles,
  ...buttonStyles,
  ...insightStyles,
  ...styles
})

type LecturePageMainProps = ReturnType<typeof mapState> &
  ReturnType<typeof mapDispatch> & {
    lectureId: string;
    active: boolean;
    onInactive?: () => void;
    onhandleContent?: () => void;
    activeInsightId?: string;
    activeMaterialIdx?: number;
  }
const ChapterTitle = React.forwardRef(
  (
    {
      chapter,
      unitIdx,
      chapterIdx
    }: { chapter: IChapter; unitIdx: number; chapterIdx: number },
    ref: any
  ) => {
    return (
      <div className={cx('message-divider')} ref={ref}>
        <span>
          <span>
            觀點 {chapterIdx + 1} {chapter.title}
          </span>
        </span>
      </div>
    )
  }
)

const scrollToElement = (
  ref: any,
  insightId: string,
  mId: number | undefined
) => {
  const screen = document.querySelector('#message-main')
  const element = document.querySelector(`#mat-${insightId}-${mId}`)

  if (screen instanceof HTMLElement && screen !== null && element) {
    // this is the amount of dis that need to be scrolled - (container offsetTop + unit width)
    const y =
      element.getBoundingClientRect().top +
      screen.scrollTop -
      (screen.offsetTop + 150) // chapterRefs[key].clientHeight
    screen.scroll({
      top: y,
      behavior: 'smooth'
    })
  } else {
    // throw new Error("element not in document")
  }
}

const ChapterContent = (
  props: LecturePageMainProps & {
    chapter: IChapter;
    unitIdx: number;
    chapterIdx: number;
  }
) => {
  const {
    participants,
    currentLecture,
    lectureId,
    chapter,
    unitIdx,
    chapterIdx,
    onInsightDelete,
    activeInsightId,
    activeMaterialIdx
  } = props

  const currentUser = firebase.auth().currentUser
  const isSpeaker =
    currentLecture !== null &&
    currentUser !== null &&
    R.contains(currentUser.uid, currentLecture.speakerIds)
  const isParticipant =
    currentUser !== null &&
    participants[lectureId] !== null &&
    participants[lectureId] !== undefined &&
    R.contains(currentUser.uid, participants[lectureId])

  const content =
    !chapter.trial && !isParticipant && !isSpeaker ? (
      <div className={cx('unit-blocker')}>
        <img src={require('./../../images/common/icon/icon-lock.png')} />
        <h4>此為付費章節，請參與講座</h4>
      </div>
    ) : isSpeaker ||
      chapter.trial ||
      (currentLecture &&
        new Date() >= currentLecture.startedAt.toDate() &&
        chapter.insightIds.length) ? (
      <div>
        {chapter.insightIds.map((insightId, idx) => (
          <InsightItem
            currentLecture={currentLecture}
            // tslint:disable-next-line jsx-no-lambda
            ref={ref =>
              insightId === activeInsightId
                ? scrollToElement(ref, activeInsightId, activeMaterialIdx)
                : null
            }
            scrollToElement={scrollToElement}
            key={insightId}
            insightId={insightId}
            lectureId={lectureId}
            activeMaterialIdx={
              activeInsightId === insightId ? activeMaterialIdx : -1
            }
            onDelete={onInsightDelete.bind(
              null,
              lectureId,
              unitIdx,
              chapterIdx,
              insightId
            )}
          />
        ))}
      </div>
    ) : (
      <div className={cx('unit-blocker')}>
        <img src={require('./../../images/common/icon/icon-waiting.png')} />
        <h4>講座內容準備中，敬請期待</h4>
      </div>
    )
  return content
}

const ChapterEditor = ({
  lectureId,
  unitIdx,
  chapterIdx,
  onInsightAdd
}: LecturePageMainProps & { unitIdx: number; chapterIdx: number }) => {
  return (
    <div className={cx('drag-edit-btns', 'insight')}>
      <button
        onClick={onInsightAdd.bind(null, lectureId, unitIdx, chapterIdx)}
        className={cx('drag-edit-btn', 'drag-edit-btns__toggle')}
      />
    </div>
  )
}

const LecturePageMain: React.SFC<LecturePageMainProps> = props => {
  const rootState = store.getState()
  // tslint:disable-next-line:prefer-const
  let chapterRefs = {}
  const currentUser = firebase.auth().currentUser
  const {
    currentLecture,
    lectureId,
    onLectureTitleChange,
    onChapterSelect,
    onInactive,
    active
  } = props
  const isSpeaker =
    currentLecture !== null &&
    currentUser !== null &&
    R.contains(currentUser.uid, currentLecture.speakerIds)
  const participants = select.participants.getByLectureId(rootState, lectureId)
  const isParticipant =
    currentUser !== null &&
    participants !== null &&
    R.contains(currentUser.uid, participants)
  // scroll
  return (
    <CardContainer className={cx('page-Lecture-c__main', { active })}>
      <div className={cx('header')}>
        <h1 className={cx('title')}>
          {currentLecture ? (
            <EditableText
              disabled={
                currentUser
                  ? !R.contains(currentUser.uid, currentLecture.speakerIds)
                  : true
              }
              defaultValue={currentLecture.title}
              placeholder="講座名稱"
              onConfirm={onLectureTitleChange.bind(null, lectureId)}
            />
          ) : (
            'N/A'
          )}
        </h1>
        <ChapterSelector
          className={cx('chapter-selector')}
          lecture={currentLecture}
          onChapterSelect={onChapterSelect.bind(null, chapterRefs)}
          lectureId={lectureId}
        />
        <button className={cx('close-btn')} onClick={onInactive} />
        {/* <button className={cx('func-btn')} /> */}
      </div>

      <div className={cx('message-main')} id="message-main">
        <div className={cx('drag-group')}>
          {currentLecture
            ? currentLecture.units.map((unit, unitIdx) =>
                unit.chapters.map((chapter, chapterIdx) => {
                  const key = `${unitIdx}-${chapterIdx}`
                  return (
                    <div key={key}>
                      <ChapterTitle
                        ref={(ref: any) => (chapterRefs[key] = ref)}
                        chapter={chapter}
                        unitIdx={unitIdx}
                        chapterIdx={chapterIdx}
                      />
                      <ChapterContent
                        {...props}
                        chapter={chapter}
                        unitIdx={unitIdx}
                        chapterIdx={chapterIdx}
                      />
                      {isSpeaker ? (
                        <ChapterEditor
                          {...props}
                          unitIdx={unitIdx}
                          chapterIdx={chapterIdx}
                        />
                      ) : null}
                    </div>
                  )
                })
              )
            : 'Loading...'}
        </div>
      </div>
      {isParticipant ? null : (
        <MediaQuery query="(max-width: 991px)">
          <Panel
            lectureId={lectureId}
            isSpeaker={isSpeaker}
            isEdit={false}
            isContent={true}
            // handleMainActive={this.handleMainActive}
            // mobileLectureContent={this.isMobileLecture}
            // onhandleContent={this.handleContent}
            isParticipant={isParticipant}
          />
        </MediaQuery>
      )}
    </CardContainer>
  )
}

const mapState = ({ lectureContent, lectures, participants }: RootState) => {
  return {
    ...lectureContent,
    participants,
    currentLecture: lectureContent.currentLectureId
      ? lectures[lectureContent.currentLectureId]
      : null
  }
}

const mapDispatch = (dispatch: Dispatch) => {
  return {
    onInsightDelete: (
      lectureId: string,
      unitIdx: number,
      chapterIdx: number,
      insightId: string
    ) => {
      dispatch.insights.deleteInsight({
        lectureId,
        unitIdx,
        chapterIdx,
        insightId
      })
    },
    onInsightAdd: (lectureId: string, unitIdx: number, chapterIdx: number) => {
      const currentUser = firebase.auth().currentUser
      if (currentUser) {
        dispatch.insights.addInsight({
          lectureId,
          unitIdx,
          chapterIdx,
          speakerId: currentUser.uid
        })
      } else {
        alert('No current user!!')
      }
    },
    onLectureTitleChange: (lectureId: string, title: string) => {
      dispatch.lectures.updateLecture({
        lectureId,
        updated: { title }
      })
    },
    onChapterSelect: (
      chapterRefs: { [key: string]: any },
      chapter: IChapter,
      unitIdx: number,
      chapterIdx: number
    ) => {
      const key = `${unitIdx}-${chapterIdx}`
      const screen = document.querySelector('#message-main')

      if (screen instanceof HTMLElement && screen !== null) {
        // this is the amount of dis that need to be scrolled - (container offsetTop + unit width)
        const y =
          chapterRefs[key].getBoundingClientRect().top +
          screen.scrollTop -
          (screen.offsetTop + 114) // chapterRefs[key].clientHeight
        screen.scroll({
          top: y,
          behavior: 'smooth'
        })
      } else {
        throw new Error('element not in document')
      }
    }
  }
}
export default connect(
  mapState,
  mapDispatch
)(LecturePageMain)



// WEBPACK FOOTER //
// ./src/pages/LecturePage/main.tsx